import { render, staticRenderFns } from "./ReadOnlyTextField.vue?vue&type=template&id=1ad80a5c&scoped=true&"
import script from "./ReadOnlyTextField.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyTextField.vue?vue&type=script&lang=js&"
import style0 from "./ReadOnlyTextField.vue?vue&type=style&index=0&id=1ad80a5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad80a5c",
  null
  
)

export default component.exports